import { graphql } from 'msw';

import { hasValidToken } from '../utils';

export const listGapAnalysisSummaries = graphql.query<
    ListGapAnalysisSummariesQuery,
    ListGapAnalysisSummariesQueryVariables
>('listGapAnalysisSummaries', (req, res, ctx) => {
    if (hasValidToken(req, 'publisher')) {
        return res(
            ctx.data({
                listGapAnalysisSummaries: [
                    {
                        gap_analysis_id:
                            '8080808080XX0000000000000X-AS80808080-2020Q3-1633443580',
                        pro: 'ASCAP' as GapProName,
                        description:
                            'ASCAP 2020Q3 Gap Analysis vs BMAT Detections',
                        performance_period: '2020Q3',
                        channel_count: 12,
                        date_created: '1633443580',
                        complete: true,
                        __typename: 'trqkGapSummary',
                    },
                    {
                        gap_analysis_id:
                            '1635786456XX0000000000000X-AS00027809-2020Q2-1636152001',
                        pro: 'ASCAP' as GapProName,
                        description:
                            'ASCAP 2020Q2 Gap Analysis vs BMAT Detections',
                        performance_period: '2020Q2',
                        channel_count: null,
                        date_created: '1636152001',
                        complete: true,
                        __typename: 'trqkGapSummary',
                    },
                    {
                        gap_analysis_id:
                            '1635786456XX0000000000000X-AS00027809-2020Q1-1636496849',
                        pro: 'ASCAP' as GapProName,
                        description:
                            'ASCAP 2020Q1 Gap Analysis vs BMAT Detections',
                        performance_period: '2020Q1',
                        channel_count: null,
                        date_created: '1636496849',
                        complete: false,
                        __typename: 'trqkGapSummary',
                    },
                ],
            }),
        );
    }

    return res();
});
